import React,{useEffect, useState} from "react";
import { useDispatch } from "react-redux";
import { clientAppUserLogin } from "../../../store/actions/User";

import Loading from "../../Loading/Loading";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import './loginSignUpT1.css'
import {  Link  } from "react-router-dom";
const TestNameInLogin = ()=>{
  
  const dispatch = useDispatch();
 
    const loginSignUpPopUp = useSelector((state)=>state?.app?.loginSignUpPopUp);
  
 const testTitle = useSelector((state)=>state?.app?.testTitle);
  
 const testImage = useSelector((state)=>state?.app?.testImage);
  

   
   
 const localToken= localStorage.getItem("profile");
 const token = useSelector((state)=>state?.user?.user?.token);


 const [loader , setLoader] =useState({status:false});
 const [login, setLogin] = useState({userEmail:'',userPassword:""
 
});

 
    return <>
      <div  className="flex-space-between" style={{gap:"10px"}}>  {testImage?<div  style={{width:"100px",padding:"10px"}}>
      <img style={{width:"100%",borderRadius:"15px"}}
       alt="logo" src={testImage} /> </div>:""}
          
<h3  style={{textAlign:"center"}}>{testTitle}</h3>

      </div>
   
    </>

}
export default TestNameInLogin;